import type {useTranslations} from 'next-intl';

export const btnInfo = (type: string, t: ReturnType<typeof useTranslations<'experiences.card'>>) => {
  let btnText;

  switch (type) {
    case 'poll':
      btnText = t('vote');
      break;
    case 'quiz':
      btnText = t('start_quiz');
      break;
    case 'challenge':
      btnText = t('start_challenge');
      break;
    case 'platform':
      btnText = t('take_part');
      break;
    case 'platform_install_app':
      btnText = t('install_app');
      break;
    case 'platform_add_solana_address':
      btnText = t('add_solana_address');
      break;
    case 'platform_register':
      btnText = t('register');
      break;
    case 'platform_ee_buy_it_now':
      btnText = t('buy_it_now');
      break;
    case 'platform_ee_auction_bid':
      btnText = t('auction_bid');
      break;
    case 'platform_admin_coins_grant':
      btnText = t('admin_coins_grant');
      break;
    case 'platform_referral_purchase':
      btnText = t('platform_referral_purchase');
      break;
    case 'platform_competition_first_visit':
      btnText = t('competition_first_visit');
      break;
    case 'platform_referral_registration':
      btnText = t('platform_referral_registration');
      break;
    case 'platform_coins_purchase':
      btnText = t('coins_purchase');
      break;
    case 'platform_gold_status_purchase':
      btnText = t('gold_status_purchase');
      break;
    case 'platform_bind_social_media':
      btnText = t('bind_social_media');
      break;
    case 'platform_watch_video':
      btnText = t('platform_watch_video');
      break;
    case 'poll_participation':
      btnText = t('vote');
      break;
    case 'quiz_participation':
      btnText = t('start_quiz');
      break;
    case 'challenge_participation':
      btnText = t('start_challenge');
      break;
    case 'platform_share_ee':
      btnText = t('share_action');
      break;
    case 'platform_share_celebrity':
      btnText = t('share');
      break;
    case 'platform_share_airdrop':
      btnText = t('share');
      break;
    case 'platform_share_leaderboard':
      btnText = t('share_my_position');
      break;
    case 'sm_growth_like':
    case 'sm_growth_comment':
    case 'sm_growth_share':
    case 'sm_growth_follow':
    case 'sm_growth_subscribe':
    case 'sm_growth_view':
    case 'sm_growth_listen':
    case 'sm_growth_watch':
    case 'sm_growth_celebrity':
      btnText = t('sm_growth');
      break;
    default:
      btnText = t('take_part');
  }

  return btnText;
};
